import { render, staticRenderFns } from "./PartnerStatistic.vue?vue&type=template&id=33a92c4d&scoped=true"
import script from "./PartnerStatistic.vue?vue&type=script&lang=ts"
export * from "./PartnerStatistic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a92c4d",
  null
  
)

export default component.exports